import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export function usePreviousLocation() {
  const location = useLocation()
  const previousLocation = useRef<string | null>(null)

  useEffect(() => {
    previousLocation.current = location.pathname + location.search
  }, [location])

  return previousLocation.current
}
